@if (productHighlights) {
  @if (!isMobileView) {
    <div>
      <div class="bold large-font">
        {{ translationService.getSustainabilityHighlightsText() }}
      </div>
      <div class="margin-top-10">
        <mat-divider></mat-divider>
      </div>
      <div class="sustainability-highlights">
        @for (highlight of sustainabilityHighlights; track highlight) {
          <img
            [ngSrc]="highlight.imageSrc"
            height="60"
            width="60"
            [alt]="highlight.alt"
            [matTooltip]="highlight.description"
          />
        }

        @if (productHighlights.recycledContentPercentage !== null) {
          <div
            class="recycling-percentage-container"
            [matTooltip]="
              translationService.getRecycledContentPercentageWithValueText(
                productHighlights.recycledContentPercentage
              )
            "
          >
            <img
              class="recycling-img"
              ngSrc="assets/sustainability_highlights/recycle.svg"
              height="60"
              width="60"
              [alt]="translationService.getRecycledContentPercentage()"
            />
            <span class="recycled-percentage"
              >{{
                roundToNearestWhole(
                  productHighlights.recycledContentPercentage
                )
              }}%</span
            >
          </div>
        }
      </div>
      @if (productHighlights.ghsClassifications) {
        <div class="row wrap">
          @for (ghs of productHighlights.ghsClassifications; track ghs) {
            <img
              [ngSrc]="getGhsImgPath(ghs.code)"
              height="65"
              width="65"
              [alt]="getGhsHazardText(ghs.code)"
              [matTooltip]="getGhsHazardText(ghs.code)"
            />
          }
        </div>
      }
      <div class="row">
        <div class="provincial-recyclability-labels">
          @for (
            label of productHighlights.provincialRecyclabilityLabels;
            track label
          ) {
            <app-provincial-recyclability-label
              [provincialRecyclabilityLabel]="label"
            ></app-provincial-recyclability-label>
          }
        </div>
      </div>
      @if (productHighlights.countryRecyclability) {
        <div class="row">
          <div class="country-recyclability">
            <app-country-recyclability-highlight
              [countryRecyclability]="productHighlights.countryRecyclability"
            ></app-country-recyclability-highlight>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="row margin-top-20">
      <span class="bold large-font">{{
        translationService.getIngredientRelatedCertificationsText()
      }}</span>
    </div>
    <div class="row margin-top-10">
      <span class="grey-text">{{
        translationService.getTapEachIconText()
      }}</span>
    </div>
    <div class="row margin-top-10">
      <div class="sustainability-highlights">
        @for (highlight of sustainabilityHighlights; track highlight) {
          <img
            [ngSrc]="highlight.imageSrc"
            height="60"
            width="60"
            [alt]="highlight.alt"
            [matTooltip]="highlight.description"
            ontouchstart="return false;"
          />
        }
        @if (productHighlights.recycledContentPercentage) {
          <div
            class="recycling-percentage-container"
            [matTooltip]="
              translationService.getRecycledContentPercentageWithValueText(
                productHighlights.recycledContentPercentage
              )
            "
          >
            <img
              class="recycling-img"
              ngSrc="assets/sustainability_highlights/recycle.svg"
              height="60"
              width="60"
              [alt]="translationService.getRecycledContentPercentage()"
              ontouchstart="return false;"
            />
            <span class="recycled-percentage"
              >{{
                roundToNearestWhole(
                  productHighlights.recycledContentPercentage
                )
              }}%</span
            >
          </div>
        }
      </div>
    </div>
    @if (productHighlights.ghsClassifications) {
      <div class="row wrap">
        @for (ghs of productHighlights.ghsClassifications; track ghs) {
          <img
            [ngSrc]="getGhsImgPath(ghs.code)"
            height="65"
            width="65"
            [alt]="getGhsHazardText(ghs.code)"
            [matTooltip]="getGhsHazardText(ghs.code)"
          />
        }
      </div>
    }

    @if (productHighlights.provincialRecyclabilityLabels) {
      <div class="row">
        <div class="provincial-recyclability-labels">
          @for (
            label of productHighlights.provincialRecyclabilityLabels;
            track label
          ) {
            <app-provincial-recyclability-label
              [provincialRecyclabilityLabel]="label"
            ></app-provincial-recyclability-label>
          }
        </div>
      </div>
    }

    @if (productHighlights.countryRecyclability) {
      <div class="row">
        <div class="country-recyclability">
          <app-country-recyclability-highlight
            [countryRecyclability]="productHighlights.countryRecyclability"
          ></app-country-recyclability-highlight>
        </div>
      </div>
    }
  }
}
